<template>
  <div class="signup-container">
    <Navigation v-if="!$vuetify.breakpoint.xs" is-landing-page />
    <MobileNavBar v-else/>
    <div class="spacer"/>
    <v-row :style="{ marginTop: $vuetify.breakpoint.xs ? '15vh' : '' }">
      <v-col class="left hidden-sm-and-down" cols="12" lg="7" md="7">
        <lottie-animation
              ref="anim"
              :animationData="require('@/assets/animations/first_animation.json')"
              :loop="true"
              :autoPlay="true"
          />
      </v-col>
      <v-col class="right d-flex flex-column justify-center" cols="12" lg="5" md="5">
          <router-view/>
      </v-col>
    </v-row>
    <Footer/>
  </div>
</template>

<script>
import google from "@/assets/google.png";
import Logo from "@/assets/guiomentorLogo.png";
import Navigation from '@/components/Navigation.vue';
import LottieAnimation from 'lottie-web-vue'
import Footer from '@/components/Footer.vue';
import MobileNavBar from "@/components/MobileNavBar";
export default {
  components: {
    MobileNavBar,
    Navigation, LottieAnimation, Footer
  },
  data() {
    return {
      google,
      Logo,
      email: "",
      password: "",
      confirmPassword: "",
      showPassword: false,
      loading: false,
      emailTaken: false,
      emailLoading: false,
      accountTypes: ["STUDENT", "MENTOR", "PARENT"],
      accountType: "",
      description: "Guiomentor is a platform directed to a niche of 10to 25 years old. Its objective is to help students to choose the best career or discipline for them according to their skills and part of interest "


    };
  },
  metaInfo() {
    return {
      title: 'Guiomentor - Sign up',
      meta: [
        {name: 'title', content: 'Guiomentor - Create Account with us'},
        {name: 'description', content: this.description},
        //Facebook
        {name: 'og:type', content: 'Website'},
        {name: 'og:title', content: "Guiomentor - Create an Account with us"},
        {name: 'og:description', content: this.description},
        {name: 'og:image', content: this.Logo},

        // Twitter
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:url', content: window.location.href},
        {name: 'twitter:title', content: "Guiomentor - Create an Account with us"},
        {name: 'twitter:description', content: this.description},
        {name: 'twitter:image', content: this.Logo},
      ]
    }
  },

};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.signup-container {
  .row {
    margin: 0;
  }
}


.left {
  margin-top: 0;
  margin-bottom: 0;

  .logo {
    width: 130px;
    height: 130px;
  }

  .mini-column {
    background: linear-gradient(to right, #b7edeb, #54ded2);
    min-height: 70%;
    max-width: 95%;
    border-radius: 5px;
  }
}


.right {}

.form {
  min-height: 450px;
  width: 85%;
  border-radius: 10px;
  padding: 30px;
  box-shadow:0px 42px 100px rgba(0, 0, 0, 0.12);

  .v-btn {
    text-transform: none !important;
  }

  .login-google {
    background: #f5f6f8 !important;
    color: rgba(66, 66, 66, 0.6) !important;
  }

  .social-img {
    width: 20px;
    height: 80%;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .form {
    width: 100%;
  }
}

</style>
